const inputGroupWrapperCls = "_275i15ddlre";
const labelCls = "_275lus8zwh";
const circleCls = "_275c1k7irvo";

export { circleCls, inputGroupWrapperCls, labelCls };
import "./atom.speed-input.style.linaria.module.css";
//# sourceMappingURL=atom.speed-input.style.js.map
